<template>
  <v-radio-group
    class="radio-group"
    v-on:change="$emit('input', $event)"
    :value="value"
    :model="value"
    :rules="radioErrors()"
  >
    <v-radio
      v-for="option in options"
      :key="option.id"
      :label="option.hint"
      :value="option.value"
      :color="'#00BFB3'"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
Vue.use(Vuelidate);
import EditText from "./EditText";

export default {
  name: "radio",
  methods: {
    radioErrors() {
      if (this.value.length == 0) {
        return ["Campo obrigatório"];
      }
      return [true];
    }
  },
  props: {
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    value: {
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      parentValue: null
    };
  },
  components: {
    [EditText.name]: EditText
  },
  computed: {
    componentValue: {
      get: function() {
        return this.value;
      },
      set: function() {
        // Communicate the change to parent component so that selectedValue can be updated
        this.$emit("change", this.id);
      }
    }
  },
  validations() {
    if (this.observations.length) {
      return {
        observations: {
          $each: {
            answer: {
              required
            }
          }
        }
      };
    }
  }
};
</script>
<style lang="scss">
.radio-group {
  margin-top: 0px;
  padding-left: 15px;
  padding-right: 15px;
}
.v-radio > .v-label {
  font-weight: 700;
  color: #474747;
  font-size: 21px;
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (max-width: 991px) {
  .v-radio > .v-label {
    font-size: 16px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/Radio.vue